import DialogTitle from '@material-ui/core/DialogTitle';
import styled from 'styled-components';

export const StylesDialogTitle = styled(DialogTitle)`
  background: ${(props) => props.theme.palette.background.light1};
  h5: ${(props) => props.theme.typography.h6};
  color: ${(props) => props.theme.palette.text.primary};
`;
